import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";

export default function EduReportView() {
  const { id } = useParams();
  const location = useLocation();
  const [report, setReport] = useState({});
  const [images, setImages] = useState([]);
  const [issues, setIssues] = useState([]);
  const [postImages, setPostImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [imgModal, setImgModal] = useState({
    img: "",
    index: 0,
    filter: "",
    issueDetails: null,
  });

  useEffect(() => {
    async function fetchReport() {
      setLoading(true);
      setError("");
      try {
        // Fetch report details
        const res = await axios.get(`${baseUrl}/detail_cleaner_report/${id}/`, {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        });
        if (res.data && res.data.data) {
          setReport(res.data.data);
        } else {
          setError("No report data found.");
        }
        // Fetch images, postimages, and issues from the new API
        const imgRes = await axios.get(`${baseUrl}/get_user_image/${id}/`, {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        });
        if (imgRes.data && imgRes.data.data) {
          setImages(imgRes.data.data.images || []);
          setIssues(imgRes.data.data.issues || []);
          setPostImages(imgRes.data.data.postimages || []);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          setError(
            "Authentication credentials were not provided or are incorrect."
          );
        } else {
          setError("Failed to fetch report details.");
        }
        setReport({});
      } finally {
        setLoading(false);
      }
    }
    fetchReport();
  }, [id]);

  const changeImg = (slide) => {
    let { index, filter } = imgModal;
    if (slide === "prv") {
      --index;
    } else {
      index++;
    }
    if (filter === "pre") {
      let data = images.filter((arr, i) => i === index);
      if (data.length === 0) return;
      setImgModal((cur) => ({ ...cur, img: data[0].images, index }));
    }
    if (filter === "post") {
      let data = postImages.filter((arr, i) => i === index);
      if (data.length === 0) return;
      setImgModal((cur) => ({ ...cur, img: data[0].postImages, index }));
    }
    if (filter === "issueImg") {
      let data = issues.filter((arr, i) => i === index);
      if (data.length === 0) return;
      setImgModal((cur) => ({
        ...cur,
        img: data[0].issue_images,
        index,
        issueDetails: {
          name: data[0].issue_name,
          reason: data[0].issue_reason,
        },
      }));
    }
  };

  if (loading) return <div className="container mt-4">Loading...</div>;
  if (error) return <div className="container mt-4 text-danger">{error}</div>;
  if (!report) return <div className="container mt-4">No report found.</div>;

  // Helper to render a row only if value is not null/empty and not hidden by cleaning type
  const shouldHideForTermCleaning = report?.cleaning_type === "TERM_CLEANING";
  const renderRow = (label, value, key) => {
    if (
      shouldHideForTermCleaning &&
      [
        "Window Closed",
        "Light Off",
        "Door Locked",
        "All replenished",
        "Window Reason",
        "Light Reason",
        "Door Reason",
        "Replenished Reason",
      ].includes(label)
    ) {
      return null;
    }
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null"
    )
      return null;
    return (
      <tr>
        <th>{label}</th>
        <td>{value}</td>
      </tr>
    );
  };

  // Function to determine cleaning type color
  const getCleaningTypeColor = (report) => {
    if (!report) return "";
    const conditions = [
      report.is_window_close === false,
      report.is_light_off === false,
      report.is_door_lock === false,
      report.all_comsumables === false,
    ];
    const falseCount = conditions.filter(Boolean).length;
    if (falseCount > 1) return "violet";
    if (report.is_window_close === false) return "yellow";
    if (report.is_light_off === false) return "green";
    if (report.is_door_lock === false) return "orange";
    if (report.all_comsumables === false) return "blue";
    return "";
  };

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-flag me-2" />
              Report Details
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/education">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Report Detail
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="cards report-dtl">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="cards report-dtl">
                  <table className="table table-bordered dtl-table">
                    <tbody>
                      {renderRow("ID", report?.id)}
                      {renderRow("Cleaner Name", report?.name_cleaner)}
                      <tr>
                        <th>Pre-Cleaning Photos</th>
                        <td>
                          <div className="table-img-box">
                            {images.length > 0 ? (
                              images.map((img, i) =>
                                img.images ? (
                                  <button
                                    key={i}
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#reportImg"
                                    onClick={() =>
                                      setImgModal({
                                        img: img.images,
                                        index: i,
                                        filter: "pre",
                                      })
                                    }
                                  >
                                    <img
                                      src={img.images}
                                      alt="reportImg"
                                      style={{ width: "8px" }}
                                    />
                                  </button>
                                ) : null
                              )
                            ) : (
                              <span>No images found.</span>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Post-Cleaning Photos</th>
                        <td>
                          <div className="table-img-box">
                            {postImages.length > 0 ? (
                              postImages.map((img, i) =>
                                img.postImages ? (
                                  <button
                                    key={i}
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#reportImg"
                                    onClick={() =>
                                      setImgModal({
                                        img: img.postImages,
                                        index: i,
                                        filter: "post",
                                      })
                                    }
                                  >
                                    <img
                                      src={img.postImages}
                                      alt="reportImg"
                                      style={{ width: "8px" }}
                                    />
                                  </button>
                                ) : null
                              )
                            ) : (
                              <span>No post images found.</span>
                            )}
                          </div>
                        </td>
                      </tr>
                      {renderRow("Location", report?.location)}
                      {renderRow("Work Description", report?.desc_of_work)}
                      {renderRow(
                        "Date/Time",
                        report?.date && report?.time
                          ? `${report.date}/ ${report.time?.split(".")[0]}`
                          : null
                      )}
                      <tr>
                        <th>Issue Images</th>
                        <td>
                          <div className="table-img-box">
                            {issues.length > 0 ? (
                              issues.map((arr, i) =>
                                arr.issue_images ? (
                                  <button
                                    key={i}
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#reportImg"
                                    onClick={() =>
                                      setImgModal({
                                        img: arr.issue_images,
                                        index: i,
                                        filter: "issueImg",
                                        issueDetails: {
                                          name: arr.issue_name,
                                          reason: arr.issue_reason,
                                        },
                                      })
                                    }
                                  >
                                    <img
                                      src={arr.issue_images}
                                      alt="reportImg"
                                      style={{ width: "8px" }}
                                    />
                                    {/* <h6>{arr.issue_name}</h6> */}
                                    {/* {arr.issue_reason && (
                                      <div>
                                        <small>
                                          Reason: {arr.issue_reason}
                                        </small>
                                      </div>
                                    )} */}
                                  </button>
                                ) : null
                              )
                            ) : (
                              <span>No issue images found.</span>
                            )}
                          </div>
                        </td>
                      </tr>
                      {renderRow("Block", report?.block_name)}
                      {/* Cleaning Type row without color coding */}
                      {renderRow("Cleaning Type", report?.cleaning_type)}
                      {renderRow(
                        "Window Closed",
                        report?.is_window_close
                          ? "Yes"
                          : report?.is_window_close === false
                          ? "No"
                          : null
                      )}
                      {renderRow("Window Reason", report?.window_reason)}
                      {renderRow(
                        "Light Off",
                        report?.is_light_off
                          ? "Yes"
                          : report?.is_light_off === false
                          ? "No"
                          : null
                      )}
                      {renderRow("Light Reason", report?.light_reason)}
                      {renderRow(
                        "Door Locked",
                        report?.is_door_lock
                          ? "Yes"
                          : report?.is_door_lock === false
                          ? "No"
                          : null
                      )}
                      {renderRow("Door Reason", report?.door_reason)}
                      {renderRow(
                        "All replenished",
                        report?.all_comsumables
                          ? "Yes"
                          : report?.all_comsumables === false
                          ? "No"
                          : null
                      )}
                      {renderRow(
                        "Replenished Reason",
                        report?.comsumables_reason
                      )}
                    </tbody>
                  </table>
                  <div className="col-lg-12 text-center">
                    <Link
                      to="/education/edu-report-management"
                      type="Submit"
                      className="thm-btn"
                    >
                      <i className="fa fa-chevron-left" /> &nbsp;back
                    </Link>
                  </div>
                  {/* Remove color coding legend from details page */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="reportImg"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <img src={imgModal.img} alt="img" />
              {imgModal.filter === "issueImg" && imgModal.issueDetails && (
                <div className="issue-details mt-3">
                  <h6 className="issue-name mb-2">
                    <strong>Issue: {imgModal.issueDetails.name}</strong>
                  </h6>
                  {imgModal.issueDetails.reason && (
                    <p className="issue-reason mb-0">
                      <strong>Reason:</strong> {imgModal.issueDetails.reason}
                    </p>
                  )}
                </div>
              )}
              <div className="btn-containermodel ">
                <button
                  className="btn btn-info mt-3"
                  onClick={() => changeImg("prv")}
                >
                  Previous{" "}
                </button>
                <button
                  className="btn btn-success mt-3"
                  onClick={() => changeImg("next")}
                >
                  {" "}
                  Next{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
